<template lang="pug">
  .form-field(:class='{ title: isTitle }')
    v-text-field(
      v-if='isInput'
      :label='field.label'
      :rules='[validate]'
      :multi-line='isTextArea'
      :auto-grow='isTextArea'
      v-model='model[field.name]'
    )
      template(slot='label')
        div(v-html='field.label')
    v-select(
      v-if='isSelect'
      v-model='model[field.name]'
      :label='field.label'
      :items='field.options'
      item-text='label'
      item-value='value'
    )
      template(slot='label')
        div(v-html='field.label')
    .headline(v-if='isTitle') {{ field.label }}
</template>

<script>
export default {
  props: [
    'field',
    'formType',
    'model',
  ],

  computed: {
    isInput() {
      return this.field.type === 'input' || this.field.type === 'textarea';
    },

    isTextArea() {
      return this.field.type === 'textarea';
    },

    isSelect() {
      return this.field.type === 'select';
    },

    isTitle() {
      return this.field.type === 'title' || this.field.type === 'title-input';
    },
  },

  methods: {
    validate() {
      if (!this.field.pattern) return true;
      const pattern = new RegExp(this.field.pattern);

      if (!pattern.test(this.model[this.field.name]) && this.model[this.field.name]) {
        return 'Formato incorrecto';
      }

      return true;
    },
  },
};
</script>

<style lang="less">
textarea {
  resize: none;
}
</style>



// WEBPACK FOOTER //
// src/components/form-field.vue